export default "__VITE_ASSET__$JWHKjM0__"